import React from 'react';

export default function TroponinMeter({ measured, limit, onMeasured, onLimit }) {
  const value = Number(measured);
  const upper = Number(limit);
  const valid = measured !== '' && limit !== '' && Number.isFinite(value) && Number.isFinite(upper) && value >= 0 && upper > 0;
  const ratio = valid ? value / upper : null;
  const points = ratio === null ? null : ratio <= 1 ? 0 : ratio <= 3 ? 1 : 2;

  return (
    <div className="field">
      <h3 className="field-title">Medidor de troponina <span className="optional">0–2 pontos</span></h3>
      <div className="number-grid">
        <label>Valor medido<input type="number" min="0" step="any" inputMode="decimal" value={measured} onChange={(event) => onMeasured(event.target.value)} placeholder="Ex.: 18" /></label>
        <label>Limite superior do laboratório<input type="number" min="0" step="any" inputMode="decimal" value={limit} onChange={(event) => onLimit(event.target.value)} placeholder="Ex.: 14" /></label>
      </div>
      {ratio !== null ? <p className="meter-result" aria-live="polite"><strong>{ratio.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}×</strong> o limite superior · <strong>{points} {points === 1 ? 'ponto' : 'pontos'}</strong></p> : <p className="field-note">Informe ambos os valores; o limite deve ser maior que zero.</p>}
      <p className="field-note">Use a mesma unidade nos dois campos. Unidades e ensaios convencionais ou de alta sensibilidade variam entre laboratórios. Até o limite = 0; acima do limite até 3× = 1; acima de 3× = 2.</p>
    </div>
  );
}
